import { appOn, getCurrentItem as getCurrentItemFromApp } from 'reactApp/appHelpers/appHelpers';
import { IS_ATTACHES, IS_PUBLIC, IS_REACT_PAGE } from 'reactApp/appHelpers/configHelpers';
import { filesFilterAll } from 'reactApp/modules/filesFilter/filesFilter.module';
import { getCurrentItem } from 'reactApp/modules/storage/storage.selectors';
import { store as reduxStore } from 'reactApp/store';


const getItem = () => IS_REACT_PAGE || IS_PUBLIC || IS_ATTACHES ? getCurrentItem(reduxStore.getState()) : getCurrentItemFromApp();

let previousItem = getItem();

appOn('routeChangeEnd', function () {
    const currentItem = getItem();

    const isPreviousFolder = !previousItem || previousItem.isFolder;
    const isCurrentFolder = currentItem && currentItem.isFolder;

    /**
     * не чистить фильтр когда
     * /MqxU/14umdPc26 -> /MqxU/14umdPc26/FileName.png
     * /MqxU/14umdPc26/FileName.png -> /MqxU/14umdPc26
     * чистим только при переходе из папки в папку
     */
    if (!currentItem || (isCurrentFolder && isPreviousFolder)) {
        reduxStore.dispatch(filesFilterAll());
    }

    previousItem = currentItem;
});
